module.exports = __webpack_public_path__ + "img/tablet.c2896c5d.png";